var React = require('react');

function TimeOff (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.25 2a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 9.25 2z","fill":"#fff","key":0}),React.createElement("path",{"d":"M9.124 19.953c1.23.51 2.57.681 3.88.505l.078-.011a.854.854 0 0 1 .121-.01c.36 0 .692.228.78.584.098.395-.144.799-.546.863a10.072 10.072 0 0 1-.318.046 9 9 0 1 1 7.874-8.576c-.016.407-.387.695-.791.646-.364-.044-.63-.347-.673-.704a.84.84 0 0 1-.006-.12v-.051l.001-.028a7.525 7.525 0 1 0-10.4 6.856z","fill":"#fff","key":1}),React.createElement("path",{"d":"M12.75 9a.75.75 0 0 0-1.5 0v3c0 .966.784 1.75 1.75 1.75h3a.75.75 0 0 0 0-1.5h-3a.25.25 0 0 1-.25-.25V9zM17 16a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4z","fill":"#fff","key":2})]);
}

TimeOff.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = TimeOff;

TimeOff.default = TimeOff;
